import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Switch } from "@/components/ui/switch";
import { getConsent, saveConsent } from "@/lib/consent";

const Btn = ({ onClick, children, testid, primary }) => (
  <button onClick={onClick} data-testid={testid}
    className={`h-11 flex-1 rounded-full px-5 text-sm font-bold transition-colors duration-200 ${primary ? "bg-[#0F2840] text-white hover:bg-[#0b1f33]" : "border border-[#0F2840] text-[#0F2840] hover:bg-slate-50"}`}>
    {children}
  </button>
);

export const CookieBanner = () => {
  const [open, setOpen] = useState(() => !getConsent());
  const [custom, setCustom] = useState(false);
  const [audience, setAudience] = useState(false);
  useEffect(() => {
    const show = () => {
      setAudience(!!getConsent()?.audience);
      setCustom(true);
      setOpen(true);
    };
    window.addEventListener("f29-open-cookies", show);
    return () => window.removeEventListener("f29-open-cookies", show);
  }, []);
  useEffect(() => {
    window.dispatchEvent(new CustomEvent("f29-cookie-dialog", { detail: open }));
  }, [open]);
  if (!open) return null;
  const choose = (v) => {
    saveConsent(v);
    setOpen(false);
  };
  return (
    <div role="dialog" aria-label="Gestion des cookies" data-testid="cookie-banner"
      className="fixed inset-x-3 bottom-3 z-[60] mx-auto max-w-2xl rounded-xl border border-slate-200 bg-white p-5 shadow-2xl sm:inset-x-6">
      <button onClick={() => choose(false)} aria-label="Fermer (vaut refus)" data-testid="cookie-close-btn" className="absolute right-3 top-2 text-xl text-slate-400 hover:text-slate-700">×</button>
      <p className="pr-6 text-sm leading-relaxed text-slate-700">
        Nous utilisons des cookies nécessaires au fonctionnement du site. Avec votre accord, nous utilisons aussi un outil de mesure d'audience (PostHog) pour améliorer le service. Vous pouvez accepter, refuser ou choisir par finalité. Votre choix peut être modifié à tout moment. <Link to="/cookies" className="font-semibold underline">En savoir plus</Link>
      </p>
      {custom && (
        <div className="mt-4 space-y-3 rounded-md bg-slate-50 p-3 text-sm" data-testid="cookie-custom-panel">
          <label className="flex items-center justify-between gap-3"><span>Cookies nécessaires (session, sécurité, choix cookies)</span><span className="text-xs font-bold text-slate-500">Toujours actifs</span></label>
          <label className="flex items-center justify-between gap-3"><span>Mesure d'audience (PostHog)</span><Switch checked={audience} onCheckedChange={setAudience} data-testid="cookie-audience-switch" /></label>
        </div>
      )}
      <div className="mt-4 flex flex-col gap-2 sm:flex-row">
        <Btn onClick={() => choose(false)} testid="cookie-refuse-btn" primary>Tout refuser</Btn>
        {custom
          ? <Btn onClick={() => choose(audience)} testid="cookie-save-btn">Enregistrer mes choix</Btn>
          : <Btn onClick={() => setCustom(true)} testid="cookie-customize-btn">Personnaliser</Btn>}
        <Btn onClick={() => choose(true)} testid="cookie-accept-btn" primary>Tout accepter</Btn>
      </div>
    </div>
  );
};
